import React from 'react'
import { Carousel } from './Carousel'
import '../style/Home.css'







export const Home = () => {
  return (
    <div>
      
      <div className='Home-Container'>
      <Carousel/>
    </div>

    
    </div>
  )
}
